import React, { useState } from 'react';
import { Card, CardBody, Col, Input, Row } from 'reactstrap';
import { formatPrice } from '../components/capitalizeFunction';
import LoadingSpiner from '../components/LoadingSpiner';
import { useRapportDay } from '../../Api/queriesRapport';

/**
 * Rapport journalier — optimisation :
 * avant : useAllCommandes + useAllPaiements + useAllDepenses puis filtres JS.
 * maintenant : GET /api/rapport/day (agrégations MongoDB, jour UTC aligné sur toISOString().slice(0, 10)).
 */
const RapportByDay = () => {
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split('T')[0]
  );

  const { data: rapport, isLoading, error } = useRapportDay(selectedDate);

  const totalCommandesNumber = rapport?.commandeCount ?? 0;
  const totalPaiements = rapport?.chiffreAffaire ?? 0;
  const totalPaiementsAmountPayed = rapport?.revenuObtenu ?? 0;
  const totalAmountNotPayed =
    totalPaiements - totalPaiementsAmountPayed || 0;
  const totalDepenses = rapport?.totalDepenses ?? 0;
  const totalAchat = rapport?.totalAchat ?? 0;
  const benefice = rapport?.benefice ?? 0;

  return (
    <React.Fragment>
      <Card style={{ boxShadow: '0px 0px 10px rgba(123, 123, 123, 0.28)' }}>
        {/* Filtrage Bouton */}
        <Row>
          <Col md={4}>
            <Card
              style={{
                background: 'linear-gradient(1deg, #183B4E 0%, #27548A 100%)',
              }}
            >
              <CardBody>
                <h6 className='text-white text-center'>
                  Sélectionnez une Date
                </h6>
                <div className='d-flex align-items-center justify-content-between mb-3'>
                  <Input
                    className='form-control serach'
                    style={{ cursor: 'pointer' }}
                    type='date'
                    max={new Date().toISOString().split('T')[0]} // Limiter à la date actuelle
                    value={selectedDate} // Valeur par défaut à la date actuelle
                    onChange={(e) => setSelectedDate(e.target.value)}
                  />
                </div>

                <div className='text-center text-white'></div>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <h4 className='text-center mt-5' style={{ color: ' #183B4E' }}>
              Rapports Journalier
            </h4>
          </Col>
        </Row>

        {error && (
          <div className='text-danger text-center px-3'>
            Erreur de chargement du rapport
          </div>
        )}
        {isLoading && <LoadingSpiner />}

        {/* Résultats */}
        <Row>
          {/* Bénefices */}
          <Col sm={6} lg={4}>
            <Card
              style={{
                background: ' #250902',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
              }}
            >
              {' '}
              <h5 className='mb-1 text-white'>Bénéfice </h5>
              {benefice <= 0 ? (
                <h4 className='text-danger'>{formatPrice(benefice)} F</h4>
              ) : (
                <h4 className='text-success'>{formatPrice(benefice)} F</h4>
              )}
            </Card>{' '}
          </Col>
          {/* Paiements */}
          <Col sm={6} lg={4}>
            <Card
              style={{
                background: ' #38040e',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
              }}
            >
              <p className='text-white'>
                Revenue (Chiffre d'Affaire)
                <i
                  className='fas fa-level-down-alt ms-2 fs-4'
                  style={{ color: '#00f504' }}
                ></i>
              </p>
              <h5 className='my-1' style={{ color: ' #00f504' }}>
                {formatPrice(totalPaiementsAmountPayed)} F
              </h5>
            </Card>{' '}
          </Col>
          <Col sm={6} lg={4}>
            <Card
              style={{
                background: ' #640d14',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
              }}
            >
              <p className='text-white'>Achat sur Revenue</p>
              <h5 className='my-1' style={{ color: ' #00f504' }}>
                {formatPrice(totalAchat)} F
              </h5>
            </Card>{' '}
          </Col>

          {/* Dépences */}
          <Col sm={6} lg={4}>
            <Card
              style={{
                background: ' #f58549',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
              }}
            >
              {' '}
              <h4 className='mb-1' style={{ color: '#901E3E' }}>
                {formatPrice(totalDepenses)} F
              </h4>
              <p className='text-white'>
                Dépenses
                <i
                  className='fas fa-level-up-alt ms-2 fs-4'
                  style={{ color: ' #901E3E' }}
                ></i>
              </p>
            </Card>{' '}
          </Col>

          {/* COMMANDE */}
          <Col sm={6} lg={4}>
            <Card
              style={{
                background: ' #ad2831',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
              }}
            >
              <h5 className='my-1' style={{ color: ' #f3f045' }}>
                {totalCommandesNumber}
              </h5>
              <p className='text-white'>Commandes</p>
            </Card>{' '}
          </Col>

          <Col sm={6} lg={4}>
            <Card
              style={{
                background: 'linear-gradient(to top right , #3E0703, #cbcaa5)',
                justifyContent: 'center',
                alignItems: 'start',
                height: '100px',
                padding: '0 10px',
              }}
            >
              <h6 className='my-1 text-light'>
                Total À Payé:{' '}
                <span className='text-light'>
                  {' '}
                  {formatPrice(totalPaiements)} F
                </span>
              </h6>
              <h6 className='my-1 text-light'>
                Net Payé:{' '}
                <span className='text-success'>
                  {' '}
                  {formatPrice(totalPaiementsAmountPayed)} F
                </span>
              </h6>
              <h6 className='my-1 text-light'>
                Impayé:{' '}
                <span className='text-danger'>
                  {' '}
                  {formatPrice(totalAmountNotPayed)} F
                </span>
              </h6>
            </Card>
          </Col>
        </Row>
      </Card>
    </React.Fragment>
  );
};

export default RapportByDay;
